import { Machine, StateNodeConfig, assign } from 'xstate'
import { CheckoutEvents } from '@mc/pre-paywall-events'
import { useStateMachine } from '@mc/state-machine'
import { GIFT_MACHINE_ID, GIFT_STATES, GIFT_TRANSITIONS } from './constants'

const setPageSource = (source: MachineContext['checkoutPageSource']) =>
  assign<MachineContext>({ checkoutPageSource: source })

export const getSendGiftMachineConfig = <TContext = MachineContext>({
  exitState = GIFT_STATES.FINISH,
}: {
  exitState?: string
} = {}) =>
  ({
    id: GIFT_MACHINE_ID,
    initial: GIFT_STATES.PROMPT,
    states: {
      [GIFT_STATES.PROMPT]: {
        entry: setPageSource(CheckoutEvents.PAGES.CART_REGISTRATION),
        always: {
          cond: (ctx: MachineContext) => ctx.skipPrompt,
          target: GIFT_STATES.SEND,
        },
        on: {
          [GIFT_TRANSITIONS.SCHEDULE_NOW]: {
            target: GIFT_STATES.SEND,
          },
          [GIFT_TRANSITIONS.SCHEDULE_LATER]: {
            target: exitState,
          },
        },
      },
      [GIFT_STATES.SEND]: {
        on: {
          [GIFT_TRANSITIONS.CHOOSE_WHEN]: {
            target: GIFT_STATES.PROMPT,
          },
          [GIFT_TRANSITIONS.GIFT_SENT]: { target: GIFT_STATES.SENT },
        },
      },
      [GIFT_STATES.SENT]: {
        on: {
          [GIFT_TRANSITIONS.EXIT]: { target: exitState },
        },
      },
      [GIFT_STATES.FINISH]: {
        type: 'final',
      },
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) as StateNodeConfig<TContext, any, any>

interface MachineContext {
  gifterName?: string
  gifterEmail?: string
  expriration?: string
  token?: string
  skipPrompt?: boolean
  checkoutPageSource?: string
}

export const sendGiftMachine = Machine<MachineContext>(
  getSendGiftMachineConfig(),
)

export const useSendGiftMachine = () => {
  const ctx = useStateMachine<MachineContext>()

  if (!ctx) {
    throw new Error('useSendGiftMachine was used outside of its Provider')
  }

  return ctx
}
